














































import Vue from 'vue';
import ButtonCpt from './ButtonCpt.vue';

export default Vue.extend({
  name: 'DialogCpt',
  components: {
    ButtonCpt,
  },
  props: {
    maxWidth: {
      type: String,
      required: false,
      default: '500',
    },
    model: {
      type: Boolean,
      required: false,
      default: false,
    },
    showActions: {
      type: Boolean,
      required: false,
      default: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  watch: {
    model() {
      this.internalModel = this.model;
    },
  },
  created() {
    this.internalModel = this.model;
  },
  data: () => ({
    internalModel: false,
  }),
  methods: {
    close() {
      this.internalModel = false;
      this.$emit('close');
    },
  },
});
